import { useEffect } from "react";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino";
import { useDispatch } from "react-redux";
import { setHistoryGames } from "../../store/gamesSlice";

export default function useFillHistories(countGames, setLoader = () => {}) {
  const dispatch = useDispatch();
  const historyGames = useAppSelector((state) => state.games.runningGames);
  const historyGamesId = useAppSelector((state) => state.games.runningGamesId);
  const currency = useAppSelector((state) => state.user.currency);

  const historyGamesLength = historyGames.length;

  useEffect(() => {
    if (countGames && countGames <= historyGamesLength) {
      setLoader(false);
      return;
    }

    try {
      const gamesId = countGames
        ? [...historyGamesId].splice(0, countGames).toString()
        : historyGamesId.toString();

      if (!gamesId) return;

      setLoader(true);
      API_CASINO.list
        .games({ gameId: gamesId, currency })
        .then((e) => {
          const list = e.data.list;
          dispatch(setHistoryGames(list));
        })
        .catch(console.error)
        .finally(() => {
          setLoader(false);
        });
    } catch (e) {
      console.error(e);
    }
  }, [historyGamesLength, countGames]);
}
